import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { Button } from '@savgroup-front-common/core/atoms/button';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ConfirmationContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.tw.radius['2xl']};
  padding: ${spacing('xl')} ${spacing(24)};
`;

export const $ConfirmationBody = styled.div`
  height: calc(100vh);
  padding: ${spacing(12)} ${spacing(72)} 0 ${spacing(72)};
  padding-top: ${spacing(32)};
  background-color: ${({ theme }) => theme.newUI.variationColors?.light5};
  @media ${media.maxWidth.md} {
    padding: ${spacing(28)};
  }

  @media ${media.maxWidth.sm} {
    padding: ${spacing('xl')};
  }
`;

export const $IconWithTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${spacing('xxl')};
  flex-direction: column;
  gap: ${spacing('lg')};
`;

export const $AccountActivationTitle = styled.div`
  font-size: ${({ theme }) => theme.tw.font.size['2xl']};
  font-weight: ${fontWeight('bold')};
`;

export const $VerificationMessage = styled.div`
  margin-bottom: ${spacing('xxl')};
  ${fontStyle('base')};
  color: ${({ theme }) => theme.newUI.defaultColors.secondaryText};
  display: flex;
  text-align: center;
  justify-content: center;
`;

export const $EmailActivationMessage = styled.div`
  ${fontStyle('base')};
  font-weight: ${fontWeight('bold')};
  display: flex;
  text-align: center;
  color: ${({ theme }) => theme.newUI.defaultColors.secondaryText};
  justify-content: center;
`;

export const $SpamMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ theme }) => theme.newUI.defaultColors.secondaryText};
`;

export const $ResendButton = styled(Button)`
  margin-top: ${spacing('xl')};
`;

export const $UserEmailValue = styled.div`
  color: ${({ theme }) => theme.newUI.defaultColors.primary};
  display: inline;
`;
